import React from "react";
import { ChevronRight } from "@mui/icons-material";
import { Stack, Box, Chip, Typography } from "@mui/material";

import { Iterable, Tag } from "types";

interface Props {
  tags: Iterable<Tag>[];
  selected: string[];
}

const getTagsTree = (tags: Iterable<Tag>[], selected: string[]) => {
  const emptyTags: string[] = [];
  const findedTags: Iterable<Tag>[] = [];

  if (tags.length === 0 || selected.length === 0) {
    return { tree: [], emptyTags: [] };
  }

  for (const item of selected) {
    const find = tags.find(({ userTags }) =>
      userTags.find((v) => [v.name, ...v.tags].includes(item))
    );

    if (find) {
      const isIncluded = findedTags.find((i) => i.name === find.name);
      if (!isIncluded) findedTags.push(find);
    } else {
      emptyTags.push(item);
    }
  }

  const filtered = findedTags.map((item) => {
    const { id, name, userTags } = item;

    const filteredUserTags = userTags.filter((i) => {
      const array = [i.name, ...i.tags].map((v) => selected.indexOf(v));
      return array.filter((number) => number !== -1).length > 0;
    });

    return { id, name, userTags: filteredUserTags };
  });

  return {
    emptyTags,
    tree: filtered.map((item) => ({
      ...item,
      userTags: item.userTags.map(({ name, tags }) => ({
        name: name,
        tags: [name, ...tags].filter((v) => selected.includes(v)),
      })),
    })),
  };
};

export const TagsTree = ({ tags, selected }: Props) => {
  const { tree, emptyTags } = getTagsTree(tags, selected);

  return (
    <Box sx={{}}>
      <Stack direction="column" spacing={1}>
        {tree.map((treeItem) => {
          const { userTags, name, id } = treeItem;

          return (
            <React.Fragment key={id}>
              {userTags.map((item) => (
                <Stack
                  direction="row"
                  alignItems="center"
                  key={`${id}-${item.name}`}
                >
                  <Chip size="medium" label={name} />
                  <ChevronRight />
                  <Chip size="small" label={item.name} />
                  <ChevronRight />

                  <Typography variant="button">{`${item.tags.join(
                    ", "
                  )}`}</Typography>
                </Stack>
              ))}
            </React.Fragment>
          );
        })}

        {emptyTags.length > 0 && (
          <Stack direction="row" alignItems="center">
            <Chip size="medium" color="error" label="Not found" />
            <ChevronRight />
            <Typography variant="button">{`${emptyTags.join(
              ", "
            )}`}</Typography>
          </Stack>
        )}
      </Stack>
    </Box>
  );
};
